import { useIntl, type IntlShape } from 'react-intl'
import { formatCruiseCabinTypeSlugLabel } from 'constants/cruise'

export function formatCruiseCabinTypeLabel(intl: IntlShape, cabinType: string): string {
  return formatCruiseCabinTypeSlugLabel(intl, cabinType) ?? cabinType
}

function useCruiseCabinTypeLabels(): Record<string, string> {
  const intl = useIntl()

  return {
    inside: formatCruiseCabinTypeLabel(intl, 'inside'),
    oceanview: formatCruiseCabinTypeLabel(intl, 'oceanview'),
    window: formatCruiseCabinTypeLabel(intl, 'window'),
    oceanview_window: formatCruiseCabinTypeLabel(intl, 'oceanview_window'),
    balcony: formatCruiseCabinTypeLabel(intl, 'balcony'),
    suite: formatCruiseCabinTypeLabel(intl, 'suite'),
  }
}

export default useCruiseCabinTypeLabels
